import React, { useEffect, useState } from "react";
import PriceCard from "../../components/PriceCard/PriceCard";
import RadioSlider from "../../components/RadioSlider/RadioSlider";
import CustomSelect from "../../components/CustomSelect/CustomSelect";
import AccordionItem from "../../components/AccordionItem/AccordionItem";
import { countries, featureComparison } from "../../countryData";
import styles from "./Pricing.module.css";
import { GreenTickIcon } from "../../assetLoader";
import "../../App.css";

const prodPricing = {
  "IND": {
    "monthly": {
      std: "₹1,349",
      prof: "₹1,699",
    },
    "annually": {
      std: "₹1,149",
      prof: "₹1,449",
    }
  },
  "UAE": {
    "monthly": {
      std: "$29.99",
      prof: "$34.99",
    },
    "annually": {
      std: "$25.49",
      prof: "$29.74",
    }
  },
  "default": {
    "monthly": {
      std: "$16.99",
      prof: "$19.99",
    },
    "annually": {
      std: "$14.49",
      prof: "$16.99",
    }
  }
}
  const addOnsPricing = {
    autodial: {
      INR: "₹500",
      USD: "$7",
    },
    callTranscript: {
      INR: "₹1",
      USD: "$0.015",
    },
    aiInsights: {
      INR: "₹0.85",
      USD: "$0.009",
    },
    browserCalling: {
      INR: "₹500",
      USD: "$7",
    },
    CNAM: {
      INR: "₹---",
      USD: "$2",
    },
    whatsappBusiness: {
      INR: "₹899",
      USD: "$9.99"
    }
  };

function Pricing() {
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "description";
    meta.content =
      "Simple and fair pricing options for Frejun. No long-term contracts—pay as you go. Compare plans, call charges, and add-ons, and start with a free trial.";

    const existingMeta = document.querySelector("meta[name='description']");
    if (existingMeta) {
      existingMeta.remove();
    }
    document.head.appendChild(meta);
  }, []);
    
  const [virtualNumber, setVirtualNumber] = useState("USA");
  const [yourVirtualNumber, setYourVirtualNumber] = useState("USA");

  const [billingCycle, setBillingCycle] = useState("Annual billing (Save 15%)");
  const [accordionClicked, setAccordionClicked] = useState("0");
  const [comparisonTableVisible, setComparisonTableVisible] = useState(false);

  const handleAccordionToggle = (index) => {
    if (accordionClicked === index) {
      return setAccordionClicked("0");
    }
    setAccordionClicked(index);
  };
  const handleChatOpen = () => {
    window?.HubSpotConversations?.widget?.open();
  };

  useEffect(() => {
    setYourVirtualNumber(virtualNumber);
  }, [virtualNumber]);

  return (
    <>
      <div>
        <div className={styles.pricing_banner}>
          <h1>Simple and fair pricing</h1>
          <h3>No long term contracts. Pay as you go.</h3>
          <div className={styles.select_container}></div>
        </div>

        <div className={styles.pricing_body}>
          <div className={styles.select_container}>
            <label>
              Country
              <CustomSelect
                id="select_1"
                value={virtualNumber}
                onChange={(val) => setVirtualNumber(val)}
                options={countries}
              />
            </label>
            <RadioSlider
              options={["Annual billing (Save 15%)", "Monthly billing"]}
              value={billingCycle}
              onChange={(newVal) => setBillingCycle(newVal)}
              containerStyle={{ width: "379px" }}
            />
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "40px",
            }}
            className={styles.price_cards}
          >
            <PriceCard
              type="STANDARD"
              price={
                prodPricing[['IND', 'UAE']?.includes(virtualNumber) ? virtualNumber : 'default']
                  [billingCycle.startsWith("M") ? "monthly" : "annually"
                ]["std"]
              }
              displayVNoFeature={countries[virtualNumber].virtual_no}
              displayUnlimitedCalling={
                countries[virtualNumber].unlimited_calling
              }
              displayCredits={virtualNumber === "IND" ? false : true}
              credits="$5"
              country={virtualNumber}
            />
            <PriceCard
              type="PROFESSIONAL"
              price={
                prodPricing[['IND', 'UAE']?.includes(virtualNumber) ? virtualNumber : 'default']
                  [billingCycle.startsWith("M") ? "monthly" : "annually"
                ]["prof"]
              }
              credits="$5"
              displayVNoFeature={countries[virtualNumber].virtual_no}
              displayUnlimitedCalling={
                countries[virtualNumber].unlimited_calling
              }
              displayCredits={virtualNumber === "IND" ? false : true}
              country={virtualNumber}
            />
          </div>
        </div>
        <div className={styles.compare_plans}>
          <button
            className={styles.btn}
            onClick={() => setComparisonTableVisible((prev) => !prev)}
          >
            Compare plans
          </button>
          {comparisonTableVisible && (
            <div className={styles.comp_table_container}>
              <table className={styles.comp_table}>
                <thead>
                  <tr className={styles.comp_table_header}>
                    <th>FEATURES</th>
                    <th style={{ textAlign: "center" }}>STANDARD</th>
                    <th style={{ textAlign: "center" }}>PROFESSIONAL</th>
                  </tr>
                </thead>
                {Object.keys(featureComparison).map((featHeader) => {
                  return (
                    <React.Fragment key={featHeader}>
                      <thead>
                        <tr className={styles.feature_heading}>
                          <td colSpan={3}>{featHeader}</td>
                        </tr>
                      </thead>
                      <tbody>
                        {featureComparison[featHeader].map((f) => {
                          if (
                            f.feature ===
                              "1 Virtual number included in plan (per user)" &&
                            !countries[virtualNumber].virtual_no
                          )
                            return null;
                          if (f.plan === 'INR' && virtualNumber !== 'IND')
                            return null;
                          return (
                            <tr key={f.feature}>
                              <td>{f.feature}</td>
                              <td style={{ textAlign: "center" }}>
                                {f.feature === "Inbound calls" &&
                                  countries[virtualNumber].rate.inbound}
                                {f.feature === "Outbound calls - Domestic" &&
                                  countries[virtualNumber].rate.outbound}
                                {f.val === true && !f.isPro ? (
                                  <span>{GreenTickIcon()}</span>
                                ) : f.val === true && f.isPro ? (
                                  ""
                                ) : (
                                  f.val
                                )}
                              </td>
                              <td style={{ textAlign: "center" }}>
                                {f.feature === "Inbound calls" &&
                                  countries[virtualNumber].rate.inbound}
                                {f.feature === "Outbound calls - Domestic" &&
                                  countries[virtualNumber].rate.outbound}
                                {f.val === true ? (
                                  <span>{GreenTickIcon()}</span>
                                ) : (
                                  f.val
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </React.Fragment>
                  );
                })}
              </table>
            </div>
          )}
          <div
            style={{
              maxWidth: "1216px",
              border: "1px solid #e1e5e2",
              margin: "24px auto 0 auto",
            }}
          ></div>
          <div className={styles.charges_container}>
            <h3 className={styles.charges_heading}>
              Virtual number &amp; call charges
            </h3>
            <div className={styles.charges_container_2}>
              <div className={styles.select_container}>
                <label>
                  Your number
                  <CustomSelect
                    id="select_2"
                    value={yourVirtualNumber}
                    onChange={(val) => {
                      setYourVirtualNumber(val);
                    }}
                    options={countries}
                  />
                </label>
              </div>
              <div className={styles.charges_table_container}>
                <table className={styles.charges_table}>
                  <tbody>
                 
                    <tr>
                      <td>Virtual number</td>
                      <td>
                        {countries[yourVirtualNumber].rate.number_rental}/month
                      </td>
                    </tr>
                    {countries[yourVirtualNumber].setup_fee && (
                      <tr>
                        <td>One-time setup fee</td>
                        <td>{countries[yourVirtualNumber].setup_fee}</td>
                      </tr>
                    )}
                    <tr>
                      <td>Inbound calls</td>
                      <td>{`${countries[yourVirtualNumber].rate.inbound}${
                        yourVirtualNumber === "IND" ? "" : "/min"
                      }`}</td>
                    </tr>
                    <tr>
                      <td>Outbound calls - Local</td>
                      <td>
                        {countries[yourVirtualNumber].rate.outbound_local ===
                        "-" ? (
                          <button style={{ background: 'none', border: 'none', color: 'green', textDecoration: 'underline', fontSize: '16px' }} onClick={handleChatOpen}>Contact us</button>
                        ) : (
                          `${countries[yourVirtualNumber].rate.outbound_local}${
                            yourVirtualNumber === "IND" ? "" : "/min"
                          }`
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>Outbound calls - International</td>
                      <td>
                        {countries[yourVirtualNumber].rate.outbound_int ===
                        "-" ? (
                            <button style={{ background: 'none', border: 'none', color: 'green', textDecoration: 'underline', fontSize: '16px' }} onClick={handleChatOpen}>Contact us</button>
                                        ) : (
                          `${countries[yourVirtualNumber].rate.outbound_int}${
                            yourVirtualNumber === "IND" ? "" : "/min"
                          }`
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div
              style={{
                maxWidth: "820px",
                border: "1px solid #e1e5e2",
                margin: "40px auto 16px auto",
              }}
            ></div>
            
            <div className={styles.notes_list}>
              <span
                style={{
                  fontSize: "16px",
                  fontWeight: "500",
                  color: "#464d48",
                }}
              >
                *
                <span style={{ borderBottom: "1px solid #464d48" }}>Note:</span>
              </span>
              <p>1. One India virtual number/user included in Indian plans. </p>
              <p>
                2. One US, UK or Canada virtual number/user included in other
                plans.{" "}
              </p>
              <p>Extra charges applicable for additional numbers.</p>
            </div>
          </div>
        </div>

        <div className={styles.add_ons}>
          <h3>Add-ons</h3>
          <div>
        <div className={styles.row}>
          <div className={styles.add_ons_card}>
            <div className={styles.add_ons_col1}>
              <h5>Autodial</h5>
              <p>
                Automatically dial list of phone numbers in a single click.
              </p>
            </div>
            <div className={styles.add_ons_col2}>
              <span className={styles.add_ons_price}>
                    {
                      addOnsPricing["autodial"][
                        virtualNumber === "IND" ? "INR" : "USD"
                      ]
                    }
                  </span>

                  <span>Per user/month</span>
            </div>
          </div>
          <div className={styles.add_ons_card}>
            <div className={styles.add_ons_col1}>
              <h5>AI Insights</h5>
              <p>
                Get AI-generated summaries, sentiment scores and more.
              </p>
            </div>
            <div className={styles.add_ons_col2}>
              <span className={styles.add_ons_price}>
                {addOnsPricing["aiInsights"][virtualNumber === "IND" ? "INR" : "USD"]}
              </span>
              <span>Per min</span>
            </div>
          </div>
        </div>
          <div className={styles.row}>
            {virtualNumber === "USA" && (
              <div className={styles.add_ons_card}>
                <div className={styles.add_ons_col1}>
                  <h5>CNAM</h5>
                  <p>
                    Display your business name on customers' phones when calling.
                  </p>
                </div>
                <div className={styles.add_ons_col2}>
                  <span className={styles.add_ons_price}>
                    {addOnsPricing["CNAM"]["USD"]}
                  </span>
                  <span>Per number/month</span>
                </div>
              </div>
            )}
            {virtualNumber === "IND" && (
              <div className={styles.add_ons_card}>
                <div className={styles.add_ons_col1}>
                  <h5>Browser calling</h5>
                  <p>
                    Make and receive calls directly from your web browser.
                  </p>
                </div>
                <div className={styles.add_ons_col2}>
                  <span className={styles.add_ons_price}>
                    {addOnsPricing["browserCalling"]["INR"]}
                  </span>
                  <span>Per user/month</span>
                </div>
              </div>
            )}
            <div className={styles.add_ons_card}>
            <div className={styles.add_ons_col1}>
              <h5>WhatsApp Business</h5>
              <p>
                Get a unified inbox for all messages, send message templates instantly and custom messages mid-conversation
              </p>
            </div>
            <div className={styles.add_ons_col2}>
              <span className={styles.add_ons_price}>
                    {
                      addOnsPricing["whatsappBusiness"][
                        virtualNumber === "IND" ? "INR" : "USD"
                      ]
                    }
                  </span>

                  <span>Per user/month</span>
            </div>
          </div>
            
                  {/* <div className={styles.add_ons_card}>
        <div className={styles.add_ons_col1}>
          <h5>Call transcript</h5>
          <p>Transcribe calls for easy reference and documentation.</p>
        </div>
        <div className={styles.add_ons_col2}>
          <span className={styles.add_ons_price}>
            {addOnsPricing["callTranscript"][virtualNumber === "IND" ? "INR" : "USD"]}
          </span>
          <span>Per min</span>
        </div>
      </div> */}
          </div>
        </div>

        </div>
        <div className={styles.trial_container}>
          <div className={styles.trial_content}>
            <p className={styles.trial_para}>Get started with free trial!</p>
            <a href="https://meetings.hubspot.com/tejam/frejun-demo-link-for-sales-team" target="blank">
              <button type="button" className={styles.trial_btn}>
                Contact us
              </button>
            </a>
          </div>
        </div>
        <div className={styles.faq_container}>
          <h2>FAQs</h2>
          <ul className={styles.faq_accordion}>
            <AccordionItem
              ques={<p>How does the pricing work?</p>}
              ans={
                <p>
                  The pricing is simple. Whatever plan you choose (Standard or
                  Professional plan) + per minute usage billing (outgoing and
                  incoming). A user can have multiple numbers. We charge for the
                  number rental only and per-minute usage billing for additional
                  numbers.
                  <br />
                  For example, if you have a US number with the standard plan
                  and want a UK number as a second number, the charges would be
                  16 USD (standard plan) + 2 USD (UK Numer rental) + per minute
                  usage billing.
                </p>
              }
              onToggle={() => handleAccordionToggle(1)}
              active={accordionClicked === 1}
            />
             <AccordionItem
              ques={
                <p>
                  Is the pricing for your service per user or per virtual
                  number?
                </p>
              }
              ans={
                <p>
                  Our pricing is per user. While the plan includes one virtual
                  number, additional charges apply for each user beyond the
                  initial included number.
                </p>
              }
              onToggle={() => handleAccordionToggle(5)}
              active={accordionClicked === 5}
            />
            <AccordionItem
              ques={<p>Do you offer any discounts?</p>}
              ans={
                <p>
                  According to our company policy, we do not provide discounts
                  for accounts with fewer than 10 users. For additional
                  information, please get in touch with{" "}
                  <a
                    className={styles.mail_link}
                    href="mailto:hello@frejun.com"
                  >
                    {" "}
                    hello@frejun.com
                  </a>
                  .
                </p>
              }
              onToggle={() => handleAccordionToggle(2)}
              active={accordionClicked === 2}
            />
            <AccordionItem
              ques={<p>Do you offer any free trials?</p>}
              ans={
                <p>
                We do provide a 60-minute trial, and as a security measure, we
                will need to collect your credit card details.
              </p>
              }
              onToggle={() => handleAccordionToggle(3)}
              active={accordionClicked === 3}
            />
            <AccordionItem
              ques={<p>I don’t know which plan to choose.</p>}
              ans={
                <p>
                If you require basic calling features, we recommend selecting
                our <em>Standard</em> calling plan. However, if you require
                more advanced features for frequent or intensive calling, we
                suggest upgrading to our <em>Professional</em> plan. For
                additional information, please get in touch with{" "}
                <a
                  className={styles.mail_link}
                  href="mailto:hello@frejun.com"
                >
                  {" "}
                  hello@frejun.com
                </a>
                .
              </p>
              }
              onToggle={() => handleAccordionToggle(4)}
              active={accordionClicked === 4}
            />

            <AccordionItem
              ques={<p>I have additional questions.</p>}
              ans={
                <p>
                For any additional questions, don't hesitate to contact us at{" "}
                <a
                  className={styles.mail_link}
                  href="mailto:hello@frejun.com"
                >
                  {" "}
                  hello@frejun.com
                </a>
                .
              </p>
              }
              onToggle={() => handleAccordionToggle(6)}
              active={accordionClicked === 6}
            />
          </ul>
        </div>
      </div>
    </>
  );
}

export default Pricing;
